/**
 * This constant is the custom class for the legal popup.
 */
 export const customClassModifierToModal = 'c-modal-porsche';
